import React from 'react'

import { HouseNightlyTripIndividualSeasonalPriceField } from './components/HouseNightlyTripIndividualSeasonalPriceField'
import { Divider } from '../../../../../../../../../atoms/divider/Divider'
import { HouseNightlyTripIndividualFieldProps } from '../../../form-container/HouseNightlyTripIndividualFormContainer'

export const HouseNightlyTripIndividualSeasonalPricesFields = (
  props: HouseNightlyTripIndividualFieldProps,
) => {
  return (
    <>
      <HouseNightlyTripIndividualSeasonalPriceField
        {...props}
        name='singleBedroom.lowPrice'
      />
      <HouseNightlyTripIndividualSeasonalPriceField
        {...props}
        name='sharedBedroom.lowPrice'
      />

      <Divider />

      <HouseNightlyTripIndividualSeasonalPriceField
        {...props}
        name='singleBedroom.mediumPrice'
      />
      <HouseNightlyTripIndividualSeasonalPriceField
        {...props}
        name='sharedBedroom.mediumPrice'
      />

      <Divider />

      <HouseNightlyTripIndividualSeasonalPriceField
        {...props}
        name='singleBedroom.highPrice'
      />
      <HouseNightlyTripIndividualSeasonalPriceField
        {...props}
        name='sharedBedroom.highPrice'
      />

      <Divider />
    </>
  )
}
